import { useAuth } from "@/context/AuthContext";

// Mirrors the backend's ROLE_HIERARCHY (backend/app/api/auth_guards.py) —
// lower rank = more privileged. Keyed by the display label since that's
// what `user.role` holds on the frontend (see ROLE_CODE_TO_LABEL in
// services/api.js); there's no role *code* available client-side.
const ROLE_RANK = {
  "Organization Admin": 0,
  "Fleet Manager": 1,
  Operator: 2,
  Viewer: 3,
};

function rank(role) {
  return ROLE_RANK[role] ?? ROLE_RANK.Viewer;
}

export function roleAtLeast(userRole, minRole) {
  return rank(userRole) <= rank(minRole);
}

// `can(minRole)` gates any action to users whose role outranks (or equals)
// `minRole`, e.g. can("Fleet Manager") is true for admins and managers,
// false for operators and viewers.
export function usePermissions() {
  const { user } = useAuth();
  const role = user?.role;
  return {
    role,
    isAdmin: roleAtLeast(role, "Organization Admin"),
    isManager: roleAtLeast(role, "Fleet Manager"),
    isOperator: roleAtLeast(role, "Operator"),
    can: (minRole) => roleAtLeast(role, minRole),
  };
}
